import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { Variants } from '../../utils/variant/variant';
import { ComponentVariant } from '../../utils/variant/variant';

@Component({
  standalone: true,
  selector: 'rt-group, [rtGroup]',
  template: '<ng-content />',
  styleUrls: ['./group.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
})
export class GroupComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'horizontal', 'vertical', 'grid', 'stacked', 'wrap', 'inline', 'keep-radius'],
  ];
  @ComponentVariant(GroupComponent.VARIANTS)
  @Input()
  public variant: string;
}
